<template>
  <el-container class="container global-main-content">
    <el-header class="header" height="90px">
      <header-bar :menu-list="topMenuList"></header-bar>
    </el-header>
    <el-container class="main-content">
      <el-aside width="180px" class="aside-left" v-if="leftMenuList && leftMenuList.length">
        <left-menu :menu-list="leftMenuList"></left-menu>
      </el-aside>

      <!-- <el-select class="project" :class="{ isCollapse: isCollapse }" v-model="currentProjectId" placeholder="请选择项目名称"
        @change="changeProject">
        <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
          :value="item.projectId"></el-option>
      </el-select> -->

      <el-main class="main" id="layout-main">
        <!-- <vj-map ref="map"></vj-map> -->
        <MenuNavigation></MenuNavigation>
        <keep-alive :include="keepAlive">
          <!-- 需要缓存的视图组件 -->
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <!-- <el-aside class="aside-right" width="320px">
        <right-block></right-block>
      </el-aside> -->
    </el-container>
  </el-container>
</template>

<script>
import HeaderBar from './HeaderBar'
import VjMap from './map/VjMap'
import LeftMenu from './LeftMenu.vue'
import MenuNavigation from '@/views/setting/MenuNavigation.vue'
// import RightBlock from './RightBlock'
export default {
  name: 'Layout',
  components: {
    HeaderBar,
    VjMap,
    LeftMenu,
    MenuNavigation
    // RightBlock
  },
  data() {
    return {
      currentProjectId: ''
    }
  },
  computed: {
    mainMenuIndex() {
      return parseInt(this.$store.state.mainMenuIndex)
    },
    topMenuList() {
      return this.$store.getters.topMenuList
    },
    leftMenuList() {
      return this.topMenuList[this.mainMenuIndex].childNode || []
    },
    projectId() {
      return this.$store.state.projectId
    },
    projectList() {
      return this.$store.state.projectList
    },
    keepAlive() {
      return this.$store.state.keepAlive
    }
  },
  watch: {
    projectId(val) {
      this.currentProjectId = val
    }
  },
  created() {
    this.currentProjectId = this.projectId
    this.loadExpire()
  },
  methods: {
    loadExpire() {
      this.$axios.get(this.$apis.common.selectCustomerInfo, {
        customerCode: this.$store.state.customer
      }).then(res => {
        if (res.validDate) {
          const start = this.$dayjs()
          const end = this.$dayjs(res.validDate)
          // 计算天数差（默认取整）
          const daysDiff = end.diff(start, 'day')
          if (daysDiff <= 30) {
            this.$alert(`有效期至 ${res.validDate}，到期联系客服18914719550`, '温馨提示', {
              confirmButtonText: '确定'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  overflow: hidden;
}

.header {
  padding: 0;
}

.aside-left {
  background: linear-gradient(to bottom, #142226, #3B4B61);
}

.aside-right {
  background: #F5F5F5;
  box-shadow: -1px 0px 0px 0px rgba(199, 199, 199, 0.77);
  margin-left: 1px;
}

.el-main {
  position: relative;
}

.main-content {
  // height: 100%;
  overflow: auto;
}

.project {
  position: absolute;
  left: 160px;
  bottom: 55px;
  width: 150px;
  height: 50px;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 0px rgba(186, 186, 186, 0.6);
  border-radius: 4px;
  z-index: 999;

  ::v-deep {

    .el-input,
    input {
      height: 100% !important;
    }
  }
}

.isCollapse {
  left: 46px;
}
</style>
